// CONSTANTS are all caps.
const NS = "Navigator";
const CLS = "navigator";
const WG = "." + CLS + "-";

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/navigator.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

import utils from '../utils';


export class Navigator {

	constructor($el) {
		// $el is the widget node return by the loadNavigator function
		this.$el = $el;
	}

	init() {
		this.setNavigator();
		this.handleOnHover();
	}

	setNavigator() {
		$(window).scroll(e => {
		    let wg = $(this.$el);
		    let currentY = $(window).scrollTop();
			let maxY = document.body.scrollHeight;

			//hide navigator on mobile
			if(!utils.checkBP('ds')) {
				if(currentY >= maxY / 3 && !wg.hasClass('is-open')) wg.addClass('is-open');

		    	if(currentY < maxY / 3 && wg.hasClass('is-open')) wg.removeClass('is-open');
			} else {
				wg.removeClass('is-open');
			}

        });
	}

	handleOnHover() {
		let _this = this;
		var $el = $(_this.$el);

		let hover = ($nav, doShow) => {
			let isLeft = $nav.hasClass(`${CLS}-left`);

			if (isLeft) _this.showPreview($el.find(`${WG}previewLeft`), doShow);
			else 		_this.showPreview($el.find(`${WG}previewRight`), doShow);
		};

		$el.find(`${WG}nav`).on('mouseenter', (e) => {
			hover($(e.currentTarget), true);
		});

		$el.find(`${WG}nav`).on('mouseleave', (e) => {
			hover($(e.currentTarget), false);
		});
	}

	showPreview($nav, doShow) {
		if(doShow) $nav.addClass('is-open');
		else $nav.removeClass('is-open');
	}
}
